/* /client/src/forms/ExchDetForm/index.js */
/* Exchange Detail Form: shows lines      */

import React, { Component } from "react";
//import "./style.css"
import Table        from 'react-bootstrap/Table';
//const titles = ["line no", "product id", "quantity", "unit"];
const titles = ["line no", "product id", "product desc", "quantity", "unit", "unit cost", "line cost"];

class ExchDetForm extends Component {

   render() {
      return (
         <div className="container">
            <br />
            <div className="row">
               <Table striped bordered hover size="sm">
                  <thead className="text-center">
                     <tr>
                        { titles.map(
                           (value, index) =>{
                              return <th key={index}> {value} </th>
                           }
                        )
                        }
                     </tr>
                  </thead>

                  <tbody>
                        { this.props.arrLines.map(
                              (rec, index) => (
                                 <tr key={rec.id}
                                    onClick={ () => this.props.handleShowDetModalEdit(rec.id) }
                                 >
                                    {/* ["id", "line_no", "product_id", "quantity", "unit_measure", "unit_cost", "unit_price"]*/}
                                    { Object.values(rec).slice(1, 8).map(
                                       (field, index) => <td key={index}> {field} </td>
                                      ) 
                                    }
                                 </tr>
                              )
                          )
                        }
                  </tbody>
               </Table>
            </div>
            <br />
         </div>
      );
   }
}

export default ExchDetForm;